"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BusinessHallNo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BusinessHallNo = function BusinessHallNo(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.312 1.533C10.43.93 9.27.625 8 .625c-2.705 0-4.909 1.38-4.997 4.093H3v1.023c.874.428 1.552 1.066 1.844 2.41l6.468-6.618zM4 9.015V8.81c0-1.13-.895-2.047-2-2.047S0 7.68 0 8.81c0 1.13.895 2.046 2 2.046v.204l2-2.046zM.53 14.977l1 1.023 2.06-2.109a9.4 9.4 0 00.91.035h7c1.379 0 2.5-.124 2.5-1.535v-1.534c1.105 0 2-.916 2-2.046s-.895-2.047-2-2.047-2 .917-2 2.047v2.557a.505.505 0 01-.5.512H5.557l1-1.023H11V9.834c0-2.558.822-3.517 2-4.093V4.718h-.003a4.894 4.894 0 00-.031-.419l3.023-3.093L14.811 0l-.012.012.178.183L.53 14.977zM6 13.927H4v.023a1 1 0 102 0v-.023zm4 0h2v.023a1 1 0 11-2 0v-.023z",
    fill: "currentColor"
  }));
};

exports.BusinessHallNo = BusinessHallNo;
var _default = BusinessHallNo;
exports.default = _default;